import {Injectable, Injector} from '@angular/core';

import {FirebaseOrgPreferencesService} from '../services/client-storage-services/firebase-services/firebase-org-preferences.service';
import {LocalStorageOrgPreferencesService} from "../services/client-storage-services/local-storage-services/local-storage-org-preferences.service";
import {ClientStorageDatasource} from "../models/client-storage.model";
import {FirebaseUserPreferencesService} from "../services/client-storage-services/firebase-services/firebase-user-preferences.service";
import {LocalStorageUserPreferencesService} from "../services/client-storage-services/local-storage-services/local-storage-user-preferences.service";
import {EnvironmentType} from "../../../environments/environment.model";
import {environment} from "../../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class ClientStorageResolver  {
  private readonly environmentType: EnvironmentType = environment.environmentType;

  constructor(
    private injector: Injector) {
  }

  resolve(route: import("@angular/router").ActivatedRouteSnapshot, state: import("@angular/router").RouterStateSnapshot) {
    const datasource = EnvironmentType.isOnPrem(this.environmentType) ? ClientStorageDatasource.LOCAL_STORAGE : ClientStorageDatasource.FIREBASE;
    switch (datasource) {
      case ClientStorageDatasource.LOCAL_STORAGE: {
        const localStorageOrgPreferencesService: LocalStorageOrgPreferencesService = this.injector.get(LocalStorageOrgPreferencesService);
        const localStorageUserPreferencesService: LocalStorageUserPreferencesService = this.injector.get(LocalStorageUserPreferencesService);
        localStorageOrgPreferencesService.getHighLevelOrgPreferences();
        localStorageUserPreferencesService.loadUserDetails();
        break;
      }
      case ClientStorageDatasource.FIREBASE: {
        const firebaseOrgPreferencesService: FirebaseOrgPreferencesService = this.injector.get(FirebaseOrgPreferencesService);
        const firebaseUserPreferencesService: FirebaseUserPreferencesService = this.injector.get(FirebaseUserPreferencesService);
        firebaseOrgPreferencesService.getHighLevelOrgPreferences();
        firebaseUserPreferencesService.loadUserDetails();

        break;
      }
    }
    return true;
  }
}
